import token from '@/user/services/token';

import Query from '../Query';

export default function Auth(query: Query) {
  if (token.accessToken) {
    query.addHeader('Authorization', `Bearer ${token.accessToken}`);
  }

  return query;
}
